/**
 * Hook to access picking mode settings.
 *
 * V1: Returns hardcoded defaults.
 * Future: Will read from the centralized useProductionSettings hook
 * in production-settings feature.
 */

import { useMemo } from 'react';

export type PickingMode = 'batch_pick' | 'pick_by_line';
// Note: 'hybrid' mode deferred to Phase 5

export interface PickingModeSettings {
  /** Current picking mode for label ordering */
  pickingMode: PickingMode;
}

/**
 * Returns picking mode for label ordering.
 *
 * @deprecated This hook will be replaced by useProductionSettings from
 * production-settings feature once we connect the settings to this module.
 */
export function usePickingMode(): PickingModeSettings {
  // V1: Default to batch_pick mode
  // Future: Read from centralized production settings
  return useMemo(
    () => ({
      pickingMode: 'batch_pick' as PickingMode,
    }),
    []
  );
}
